module.exports = __webpack_public_path__ + "img/pickup_dashboard.7b30ef6d.svg";